import {MessageBox} from 'element-ui'

//公共帮助
var Common = {
  showMsg: function (msg, callback, title) {

    if (title == null || title.length == 0) {
      title = "提示";
    }
    MessageBox.alert(msg, title, {
      confirmButtonText: '确定',
      callback: action => {
        typeof callback === "function" ? callback() : false;
      }
    });
  },
  confirmDialog: function (msg, comfirmCallback, cancelCallback, title) {
    if (title == null || title.length == 0) {
      title = "提示";
    }
    MessageBox.confirm(msg, title, {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      typeof comfirmCallback === "function" ? comfirmCallback() : false;
    }).catch(() => {
      typeof cancelCallback === "function" ? cancelCallback() : false;
    });
  },


}
export default Common



// WEBPACK FOOTER //
// ./src/utils/common.js